import script from "./exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./exchange.vue?vue&type=script&setup=true&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=47030f10&scoped=true&lang=scss"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47030f10"]])

export default __exports__